class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#SearchDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderSearchIconAccessibility();
    this.checkAndHandleSearchState();

  }

  checkAndHandleSearchState() {
  
    const isLoggedIn = document.body.classList.contains('customer-logged-in');
    if (isLoggedIn) {
      this.close();
    }
  }

  setHeaderSearchIconAccessibility() {
    const searchLinks = [
      document.querySelector("#search-icon-bubble"),
      document.querySelector("#search-icon-bubble2")
    ].filter(Boolean);
  
    if (searchLinks.length === 0) return;
  
    searchLinks.forEach((searchLink) => {
      searchLink.setAttribute("role", "button");
      searchLink.setAttribute("aria-haspopup", "dialog");
  
      searchLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(searchLink);
      });
  
      searchLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(searchLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const searchDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (searchDrawerNote && !searchDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(searchDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    const hikoContainer = this.querySelector('[name="hiko-container"]');
    const registerBlock = this.querySelector('.search-drawer-register');
    if (hikoContainer && registerBlock) {
        hikoContainer.parentNode.insertBefore(registerBlock, hikoContainer.nextSibling);
    }

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("SearchDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.style.setProperty('overflow', 'hidden', 'important');
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.style.setProperty('overflow', '', 'important');
  }

  setSummaryAccessibility(searchDrawerNote) {
    searchDrawerNote.setAttribute("role", "button");
    searchDrawerNote.setAttribute("aria-expanded", "false");

    if (searchDrawerNote.nextElementSibling.getAttribute("id")) {
      searchDrawerNote.setAttribute(
        "aria-controls",
        searchDrawerNote.nextElementSibling.id
      );
    }

    searchDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    searchDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#SearchDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "search-drawer",
        selector: "#SearchDrawer",
      },
      {
        id: "search-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("search-drawer", SearchDrawer);
